(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2595],{

/***/ 37829:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacto/ventas",
      function () {
        return __webpack_require__(71167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PrimaryTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/PrimaryTitle/PrimaryTitle.js



var defaultProps = {
    level: 1,
    className: "",
    fontSize: "text-3xl md:text-4xl lg:text-6xl"
};
var propTypes = {
    level: prop_types_default().oneOf([
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    className: (prop_types_default()).string,
    fontSize: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
function PrimaryTitle(param) {
    var level = param.level, className = param.className, fontSize = param.fontSize, children = param.children;
    var Level = "h".concat(level);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Level, {
        className: (0,clsx_m/* default */.Z)(fontSize, "font-extrabold tracking-tight", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "leading-10 md:leading-snug",
            children: children
        })
    });
};
PrimaryTitle.defaultProps = defaultProps;
PrimaryTitle.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/PrimaryTitle/index.js

/* harmony default export */ var components_PrimaryTitle = (PrimaryTitle);


/***/ }),

/***/ 71167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/PrimaryTitle/index.js + 1 modules
var PrimaryTitle = __webpack_require__(53208);
// EXTERNAL MODULE: ./src/components/Lead/index.js + 1 modules
var Lead = __webpack_require__(59679);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Forms/index.js + 26 modules
var Forms = __webpack_require__(91212);
// EXTERNAL MODULE: ./src/components/Toaster/index.js + 4 modules
var Toaster = __webpack_require__(19232);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/domain/countries.js + 1 modules
var countries = __webpack_require__(74907);
;// CONCATENATED MODULE: ./src/domain/SalesForm/salesFormValidationSchema.js


/* harmony default export */ var salesFormValidationSchema = (es/* object */.Ry().shape({
    firstname: es/* string */.Z_().required("Este campo es requerido").matches(/^[a-zA-Z0-9 ]+$/i, "Solo se permiten valores alfanum\xe9ricos"),
    lastname: es/* string */.Z_().required("Este campo es requerido").matches(/^[a-zA-Z0-9 ]+$/i, "Solo se permiten valores alfanum\xe9ricos"),
    company: es/* string */.Z_().required("Este campo es requerido"),
    country: es/* string */.Z_().required("Este campo es requerido").oneOf((0,countries/* countryCodes */.n)(), "Solo se permite un c\xf3digo de dos letras v\xe1lido"),
    email: es/* string */.Z_().email("Escriba una direcci\xf3n de correo v\xe1lida").required("Este campo es requerido"),
    website: es/* string */.Z_().notRequired()
}));

;// CONCATENATED MODULE: ./src/domain/SalesForm/SalesForm.js






var defaultProps = {
    onSuccess: function() {
        return (0,Toaster/* notifySuccess */.t5)("\n    Tu mensaje se ha enviado. Uno de nuestros agentes se\n    estar\xe1 poniendo en contacto lo m\xe1s pronto posible.\n  ");
    },
    onError: function() {
        return (0,Toaster/* notifyError */.cB)("\n    Ha ocurrido un error cuando intentamos enviar tu mensaje.\n    Por favor int\xe9ntalo nuevamente.\n  ");
    }
};
var propTypes = {
    onSuccess: (prop_types_default()).func,
    onError: (prop_types_default()).func,
    children: (prop_types_default()).func.isRequired
};
function SalesForm(param) {
    var onSuccess = param.onSuccess, onError = param.onError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* default */.ZP, {
        initialValues: {
            firstname: "",
            lastname: "",
            company: "",
            email: "",
            country: "",
            message: "",
            website: ""
        },
        validationSchema: salesFormValidationSchema,
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting, resetForm = param.resetForm;
            (0,Forms/* submitForm */.R2)("7663692/39eaade9-5eb1-4278-a4e8-cca475a3ffdd", values, {
                setSubmitting: setSubmitting,
                onSuccess: function onSuccess1() {
                    resetForm();
                    onSuccess();
                },
                onError: function onError1(errors) {
                    onError();
                }
            });
        },
        children: function(param) {
            var handleChange = param.handleChange, handleBlur = param.handleBlur, isSubmitting = param.isSubmitting, setFieldValue = param.setFieldValue, validateForm = param.validateForm, errors = param.errors, touched = param.touched, values = param.values, isValid = param.isValid;
            var countryHasError = touched.country && errors.country !== undefined;
            var _obj;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-4 lg:space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 lg:gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:col-span-1 space-y-4 lg:space-y-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                        htmlFor: "firstname",
                                        label: "Nombres",
                                        error: errors.firstname,
                                        touched: touched.firstname,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                            id: "firstname",
                                            name: "firstname",
                                            placeholder: "Juan",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.firstname,
                                            disabled: isSubmitting,
                                            error: errors.firstname,
                                            touched: touched.firstname,
                                            required: true
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:col-span-1 space-y-4 lg:space-y-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                        htmlFor: "lastname",
                                        label: "Apellidos",
                                        error: errors.lastname,
                                        touched: touched.lastname,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                            id: "lastname",
                                            name: "lastname",
                                            placeholder: "D\xedaz",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.lastname,
                                            disabled: isSubmitting,
                                            error: errors.lastname,
                                            touched: touched.lastname,
                                            required: true
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "company",
                            label: "Empresa",
                            error: errors.company,
                            touched: touched.company,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                id: "company",
                                name: "company",
                                placeholder: "Agile Company",
                                onChange: handleChange,
                                onBlur: handleBlur,
                                value: values.company,
                                disabled: isSubmitting,
                                error: errors.company,
                                touched: touched.company,
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "email",
                            label: "Correo electr\xf3nico de trabajo",
                            error: errors.email,
                            touched: touched.email,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* EmailFieldControl */.MG, {
                                id: "email",
                                name: "email",
                                placeholder: "juan.diaz@ejemplo.com",
                                onChange: handleChange,
                                onBlur: handleBlur,
                                value: values.email,
                                disabled: isSubmitting,
                                error: errors.email,
                                touched: touched.email,
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        className: "relative z-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "country",
                            label: "Pa\xeds",
                            error: errors.country,
                            touched: touched.country,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* CountryFieldControl */.n8, (_obj = {
                                htmlId: "country",
                                name: "country",
                                onChange: handleChange,
                                onBlur: handleBlur,
                                setFieldValue: setFieldValue,
                                validateForm: validateForm,
                                value: values.country,
                                disabled: isSubmitting,
                                error: errors.country,
                                hasError: countryHasError
                            }, (0,_define_property/* default */.Z)(_obj, "error", errors.country), (0,_define_property/* default */.Z)(_obj, "touched", touched.country), (0,_define_property/* default */.Z)(_obj, "required", true), _obj))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                            htmlFor: "message",
                            label: "Mensaje",
                            error: errors.message,
                            touched: touched.message,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextAreaControl */.ND, {
                                id: "message",
                                name: "message",
                                placeholder: "Cu\xe9ntenos m\xe1s sobre su proyecto, necesidades y cronograma.",
                                onChange: handleChange,
                                onBlur: handleBlur,
                                value: values.message,
                                disabled: isSubmitting,
                                error: errors.message,
                                touched: touched.message
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormActions */.iN, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormSubmit */.Ow, {
                            label: "Contactar con ventas",
                            submitting: isSubmitting,
                            disabled: isValid === false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "h",
                        autoComplete: "off",
                        type: "text",
                        id: "website",
                        name: "website",
                        placeholder: "Sitio web",
                        onChange: handleChange,
                        value: values.website
                    })
                ]
            });
        }
    });
};
SalesForm.defaultProps = defaultProps;
SalesForm.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/domain/SalesForm/index.js

/* harmony default export */ var domain_SalesForm = (SalesForm);

;// CONCATENATED MODULE: ./src/pages/contacto/ventas/index.js





function Contact() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col space-y-10 bg-gray-100 py-10 lg:space-y-16 lg:py-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                maxWidth: "max-w-screen-lg",
                className: "relative z-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-4 text-center lg:space-y-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryTitle/* default */.Z, {
                            fontSize: "text-2xl md:text-5xl lg:px-10 tracking-tight",
                            children: "Cont\xe1ctenos"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "leading-relaxed",
                                children: "Nuestro equipo comercial estar\xe1 encantado de responder a sus preguntas sobre ventas. Complete el siguiente formulario y nos pondremos en contacto lo antes posible."
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
                maxWidth: "max-w-screen-md",
                className: "relative z-10 space-y-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-screen-sm rounded-lg bg-white shadow-lg lg:rounded-xl lg:shadow-2xl xl:rounded-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(domain_SalesForm, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto grid max-w-screen-sm rounded-lg bg-white p-8 shadow-lg md:flex md:gap-6 lg:rounded-xl lg:shadow-xl xl:rounded-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "42",
                                    height: "42",
                                    viewBox: "0 0 42 42",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        fill: "none",
                                        fillRule: "evenodd",
                                        transform: "translate(0 2)",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "fill-current text-green-400",
                                                d: "M23.3687586,30.1425368 C20.9219925,32.1886371 17.7706231,33.4201682 14.3316134,33.4201682 C11.6954209,33.4201682 9.22824798,32.6965111 7.11790903,31.4370107 L0.720671335,33.5694159 C0.184840538,33.7480255 -0.0887912638,33.4605854 0.0863663199,32.9351109 L2.21876868,26.5378816 C0.959266296,24.4275489 0.235608095,21.9603837 0.235608095,19.3241995 C0.235608095,11.8043462 6.12405444,5.6598097 13.5415258,5.25 C11.8174159,7.83464563 10.8124059,10.939934 10.8124059,14.279955 C10.8124059,21.9925795 16.1713145,28.4535638 23.3687608,30.1425372 Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "fill-current text-green-200",
                                                d: "M39.33385,21.3096508 C40.5933524,19.1993181 41.3170106,16.7321529 41.3170106,14.0959687 C41.3170106,6.31098016 35.0060141,1.77635684e-14 27.2210053,1.77635684e-14 C19.4359965,1.77635684e-14 13.125,6.31098016 13.125,14.0959687 C13.125,21.8809573 19.4359965,28.1919374 27.2210053,28.1919374 C29.8571978,28.1919374 32.3243707,27.4682803 34.4347097,26.2087798 L40.8319474,28.341185 C41.3677782,28.5197947 41.64141,28.2323546 41.4662524,27.70688 L39.33385,21.3096508 Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                cx: "22.313",
                                                cy: "16.188",
                                                className: "fill-current text-green-900",
                                                rx: "1.313",
                                                ry: "1.313"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                cx: "27.125",
                                                cy: "16.188",
                                                className: "fill-current text-green-900",
                                                rx: "1.313",
                                                ry: "1.313"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                cx: "31.938",
                                                cy: "16.188",
                                                className: "fill-current text-green-900",
                                                rx: "1.313",
                                                ry: "1.313"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-2 md:flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-lg font-semibold",
                                        children: "Comunicaci\xf3n general"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-gray-700",
                                        children: [
                                            "Para consultas generales, incluidas oportunidades de asociaci\xf3n, env\xede un correo electr\xf3nico a\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:info@aibes.org",
                                                className: "font-medium text-gray-900",
                                                children: "info@aibes.org"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute bottom-0 left-0 right-0 z-0 hidden h-3/5 lg:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 w-full -skew-y-6 transform bg-green-500"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-0 right-0 bottom-0 h-2/5 bg-green-500"
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,2175,6225,4231,1212,5531,9774,2888,179], function() { return __webpack_exec__(37829); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);